import { render, staticRenderFns } from "./Group.vue?vue&type=template&id=282a5cc2&"
import script from "./Group.vue?vue&type=script&lang=js&"
export * from "./Group.vue?vue&type=script&lang=js&"
import style0 from "./Group.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports